import { render } from "./ApiMO.vue?vue&type=template&id=8cc06020"
import script from "./ApiMO.vue?vue&type=script&lang=js"
export * from "./ApiMO.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__